// extracted by mini-css-extract-plugin
export default {"section":"DeptTab_section__ShKoU","title":"DeptTab_title__FXlGC"};